import { useClientPortalEoirPublicData } from '../../hooks/use-client-portal-eoir-public-data'

export const useClientPortalEoirPublicContent = () => {
  const { dataClientPortalEoirPublic } = useClientPortalEoirPublicData()

  const caseData = dataClientPortalEoirPublic?.caseInformation
  const companyData = dataClientPortalEoirPublic?.company
  const currentStatusData = dataClientPortalEoirPublic?.currentStatus
  const historyData = dataClientPortalEoirPublic?.history
  const nextHearingData = dataClientPortalEoirPublic?.nextHearing
  const courtData = dataClientPortalEoirPublic?.courtInformation
  const scheduledAlertsData = dataClientPortalEoirPublic?.alertSchedule

  const existsScheduledAlertsData = !!scheduledAlertsData && scheduledAlertsData.length > 0

  const showsOtherCriticalDates = existsScheduledAlertsData

  return {
    caseData,
    companyData,
    currentStatusData,
    historyData,
    nextHearingData,
    courtData,
    scheduledAlertsData,
    showsOtherCriticalDates,
  }
}
